import { css, styled } from '@slal/ui';
import { TBody, TD, TFoot, TH, THead, TR, Table } from '@slal/ui/layout';

const borderWidth = '1px';

const cellPaddingStyles = css`
    padding: 16px 24px !important;
`;

export const StyledTD = styled(TD)`
    ${cellPaddingStyles}
    height: 50px;
`;

export const StyledTH = styled(TH)`
    ${cellPaddingStyles}
    font-size: ${({ theme }) => theme.fontSizes[4]};
    font-family: ${({ theme }) => theme.fonts.sansSerif.family};
    font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.bold} !important;
    color: ${({ theme }) => theme.colors.blue__primary__70};
    background-color: ${({ theme }) => theme.colors.neutral__light__40};

    &:nth-child(1) {
        width: 50%;
    }
    &:nth-child(2),
    &:nth-child(3) {
        width: 25%;
    }
`;

export const StyledTR = styled(TR)`
    border-bottom: ${borderWidth} solid ${({ theme }) => theme.colors.neutral__light__40};

    &:last-child {
        border-bottom: none;
    }
`;

export const StyledTHead = styled(THead)`
    ${StyledTR} {
        ${StyledTH} {
            border-bottom: ${borderWidth} solid ${({ theme }) => theme.colors.neutral__light__40};
        }
    }
`;

export const StyledTBody = styled(TBody)`
    ${StyledTR} {
        ${StyledTD} {
            /* Ensure all cells are styled consistently */
        }
    }
`;

export const StyledTFoot = styled(TFoot)`
    ${StyledTR} {
        background-color: ${({ theme }) => theme.colors.blue__secondary__10};
        ${StyledTD} {
            font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.bold};
            text-align: right;
        }
    }
`;

export const StyledTable = styled(Table)`
    margin-top: 14px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.neutral__light__30};
    border-collapse: collapse;
    border-spacing: 0;
`;
